import { axis } from '../shape';
import MinimapInstance from './minimapInstance';

export default class Minimap {
  constructor(instance) {
    this.instance = instance;
    instance.on('preprocessoptions', (event, options) => this.onPreprocessOptions(options));
    instance.chart.on('datazoom', (event) => this.onDataZoom(event));
    this.minimaps = [];
  }

  onPreprocessOptions(options) {
    this.axisMinimaps = axis.reduce((r, a) => {
      r[a] = {};
      return r;
    }, {});

    if (!options.dataZoom) {
      options.dataZoom = [];
    }

    _.each(options.grid, (grid, i) => {
      if (grid.type == 'minimap') {
        if (!this.minimaps[i]) {
          this.minimaps[i] = new MinimapInstance(i, options, this.instance);
        } else {
          this.minimaps[i].processOptions(i, options);
        }

        axis.forEach((a) => {
          _.each(this.minimaps[i].sourceAxis[a], (c, s) => {
            this.axisMinimaps[a][s] = this.axisMinimaps[a][s] || {};
            this.axisMinimaps[a][s][grid.id] = this.minimaps[i];
          });
        });
      } else if (this.minimaps[i]) {
        this.minimaps[i].destroy();
        delete this.minimaps[i];
      }
    });
  }

  onDataZoom(event) {
    // console.log(event);
    event.batch.forEach((e) => {
      if (e.dataZoomId) {
        const options = this.instance.chart.getOption();
        let dz = options.dataZoom.find((dz) => dz.id == e.dataZoomId);
        if (dz) {
          axis.forEach((a) => {
            const mmInst = this.minimaps.find((mm)=>mm&&mm.dataZoomId[a]===e.dataZoomId);
            if(mmInst){
              mmInst.sync(a, e, options);
            }else{
              _.each(dz[`${a}AxisIndex`], (i) => {
                if (this.axisMinimaps[a][i]) {
                  _.each(this.axisMinimaps[a][i], (mm) => {
                    mm.onSourceChange(a, e);
                  });
                }
              });
            }
          });
        }
      }
    });
    //minimaps.each((mm) => mm.update());
  }
}
